import React from 'react';

const SpecsLink = (props) => {
	const { changeTab, product, suppliesCats = { '70m-W': 1 } } = props;
	const {compatiblePrinters={}, categories, attributes={} } = product;

	let isSupply = false;
	let specsText = 'See all Specs';
	
	if (product && compatiblePrinters.value && compatiblePrinters.value.length > 0) {
		isSupply = (categories || []).find((cat) => cat in suppliesCats);
		specsText = isSupply ? 'See compatible printers' : specsText;
	}
	if (attributes.hideSpecsTab) {
		return null;
	}

	return (
		<div className={`spec-link ${isSupply ? 'emphasize-text' : ''}`}>
			<span onClick={changeTab('Specs')}>{specsText}</span>
		</div>
	);
};

export default SpecsLink;
